import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {gsap} from "gsap";
import {GameModeNames} from "../server/GameModeNames";
import {Game} from "../Game";
import { IFadeTrackConf } from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import { NolimitHowl } from "@nolimitcity/slot-audio/bin/NolimitHowl";

export class Sound {

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6", "reelLanding7", "reelLanding8", "reelLanding9"];
    public static REELS_COLLAPSE: string[] = ["reelCollapse1", "reelCollapse2", "reelCollapse3", "reelCollapse4", "reelCollapse5", "reelCollapse6", "reelCollapse7", "reelCollapse8", "reelCollapse9"];
    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static MAIN_BG_AMBIENCE: string = "background-ambience";

    // reel sound
    public static REEL1_SPIN: string = "reelSpin1";
    public static REEL2_SPIN: string = "reelSpin2";
    public static REEL3_SPIN: string = "reelSpin3";
    public static REEL4_SPIN: string = "reelSpin4";

    // tank sound
    public static TANK_START: string = "tankStart";
    public static TANK_STOP: string = "tankStop";
    public static TANK_DRIVE_LOOP: string = "tankDriveLoop";
    public static TANK_U_TURN: string = "tankUturn";
    public static TANK_LAND1: string = "tankLand1";
    public static TANK_LAND2: string = "tankLand2";
    public static TANK_LAND3: string = "tankLand3";
    public static TANK_LAND4: string = "tankLand4";

    // scatter sound
    public static SCATTER_LAND1: string = "scatterLand1";
    public static SCATTER_LAND2: string = "scatterLand2";
    public static SCATTER_LAND3: string = "scatterLand3";
    public static SCATTER_LAND4: string = "scatterLand4";

    // wild sound
    public static WILD_LAND1: string = "wildLand1";
    public static WILD_LAND2: string = "wildLand2";
    public static WILD_LAND3: string = "wildLand3";
    public static WILD_LAND4: string = "wildLand4";

    // split sound
    public static XS_LAND: string = "splitLand";
    public static XS_ACTIVATE: string = "splitActivate";

    // grenade sound
    public static GR_LAND: string = "boosterGrenadeLand";
    public static GR_PICK: string = "boosterGrenadePickup";
    public static GR_ACTIVATE: string = "boosterGrenadeActivate";
    public static GR_EXPLODE: string = "boosterGrenadeExplosion";

    // played on grenade & bazooka execution
    public static SNARE_PLAYER: string = "mainSnarePlayer";

    // airstrike sound
    public static AS_LAND: string = "boosterAirStrikeLand";
    public static AS_PICK: string = "boosterAirStrikePickup";
    public static AS_SNARE: string = "mainSnareBand";
    public static AS_ACTIVATE: string = "boosterAirStrikeActivate";

    // bazooka sound
    public static BZ_LAND: string = "boosterRocketLand";
    public static BZ_PICK: string = "boosterRocketPickup";
    public static BZ_ACTIVATE: string = "boosterRocketActivate";
    public static BZ_EXPLODE: string = "boosterRocketExplosion";

    // bulldozer sound
    public static BU_LAND: string = "boosterPowerDrillLand";
    public static BU_PICK: string = "boosterPowerDrillPickup";
    public static BU_ACTIVATE: string = "boosterPowerDrillActivate";
    public static BU_EXPLODE: string = "boosterPowerDrillExplosion";
    public static xLOOT_DRILL1: string = "xLootDrill1";
    public static xLOOT_DRILL2: string = "xLootDrill2";
    public static xLOOT_DRILL3: string = "xLootDrill3";
    public static xLOOT_DRILL4: string = "xLootDrill4";
    public static BU_DRILL_START: string = "boosterPowerDrillStart";
    public static BU_DRILL_LOOP: string = "boosterPowerDrillLoop";
    public static BU_DRILL_LOOP_STOP: string = "boosterPowerDrillStop";

    // XB sound
    public static XB_LAND: string = "xBombLand";
    public static XB_EXPLODE: string = "xBombExplode";

    // GE sound
    public static GE_LAND: string = "barrelBombLand";
    public static GE_EXPLODE: string = "barrelBombExplode";
    
    // Suicide bomb sound
    public static SUICIDE_BOMB: string = "boom3";
    public static SUICIDE_BOMB_BIG: string = "boom4";
    
    // attack sound
    public static ATTACK_HIGHLIGHT: string = "attackHighlight";

    // funeral sound
    public static FUNERAL: string = "funeral";

    // XNudge sound
    public static XN_LAND: string = "xNudgeLand";
    public static XN_MOVE1: string = "xNudgeMove1";
    public static XN_MOVE2: string = "xNudgeMove2";
    public static XN_MOVE3: string = "xNudgeMove3";
    public static XN_MOVE4: string = "xNudgeMove4";

    // xLoot sound
    public static LOOT_PICKUP_HIGHLIGHT: string = "xLootPickupHighlight";
    public static LOOT_HIGHLIGHT: string = "xLootHighlight";
    public static LOOT_VANISH: string = "xLootVanish";
    public static LOOT_UPGRADE: string = "xLootUpgrade";
    
    public static LOOT_RED1: string = "xLootRed1";
    public static LOOT_RED2: string = "xLootRed2";
    public static LOOT_RED3: string = "xLootRed3";
    public static LOOT_RED4: string = "xLootRed4";

    public static LOOT_GREEN1: string = "xLootGreen1";
    public static LOOT_GREEN2: string = "xLootGreen2";
    public static LOOT_GREEN3: string = "xLootGreen3";
    public static LOOT_GREEN4: string = "xLootGreen4";

    public static LOOT_CYAN1: string = "xLootCyan1";
    public static LOOT_CYAN2: string = "xLootCyan2";
    public static LOOT_CYAN3: string = "xLootCyan3";
    public static LOOT_CYAN4: string = "xLootCyan4";

    public static LOOT_BLUE1: string = "xLootBlue1";
    public static LOOT_BLUE2: string = "xLootBlue2";
    public static LOOT_BLUE3: string = "xLootBlue3";
    public static LOOT_BLUE4: string = "xLootBlue4";

    // win sound
    public static WIN_TINY: string = "winTiny";
    public static WIN_SMALL: string = "winSmall";
    public static WIN_MID: string = "winMid";
    public static WIN_LARGE: string = "winLarge";
    public static AS_WIN: string = "asWin";

    // bigWin sound
    public static BIG_WIN_LEVEL1: string = "bigwinLevel1";
    public static BIG_WIN_LEVEL2: string = "bigwinLevel2";
    public static BIG_WIN_LEVEL3: string = "bigwinLevel3";
    public static BIG_WIN_LEVEL4: string = "bigwinLevel4";
    public static BIG_WIN_LEVEL5: string = "bigwinLevel5";
    public static BIG_WIN_INTRO: string = "bigwinIntro";
    public static BIG_WIN_OUTRO: string = "bigwinOutro";
    public static AS_WIN_BIG: string = "asWinBig";

    // win cap sound
    public static WIN_CAP_INTRO: string = "wincapIntro";
    public static WIN_CAP_START: string = "wincapStart";
    public static WIN_CAP_LOOP: string = "wincapLoop";
    
    // multiplier land sound
    public static CRATE1: string = "crate1";
    public static CRATE2: string = "crate2";
    public static CRATE3: string = "crate3";
    public static CRATE4: string = "crate4";
    
    // multiplier pickup sound
    public static CRATE_PICK_M2_M8: string = "cratePickupM2-M8";
    public static CRATE_PICK_M10_M50: string = "cratePickupM10-M50";
    public static CRATE_PICK_M100_M500: string = "cratePickupM100-M500";
    public static CRATE_PICK_M1000: string = "cratePickupM1000";
    public static CRATE_PICK_M2000: string = "cratePickupM2000";
    public static CRATE_SHIMMER1: string = "crateShimmer1";
    public static CRATE_SHIMMER2: string = "crateShimmer2";
    public static CRATE_SHIMMER3: string = "crateShimmer3";
    public static MULTI_CHEST_OPEN: string = "multiChestOpen";

    // wild pick sound
    public static xLOOT_WILD_PICK1: string = "xLootWild1";
    public static xLOOT_WILD_PICK2: string = "xLootWild2";
    public static xLOOT_WILD_PICK3: string = "xLootWild3";
    public static xLOOT_WILD_PICK4: string = "xLootWild4";
    
    // scatter pickup sound
    public static SCATTER_PICK1: string = "scatterPickup1";
    public static SCATTER_PICK2: string = "scatterPickup2";
    public static SCATTER_PICK3: string = "scatterPickup3";
    public static SCATTER_PICK4: string = "scatterPickup4";
    
    // heart sound
    public static HEART_LOSE1: string = "heartLose1";
    public static HEART_LOSE2: string = "heartLose2";
    public static HEART_LOSE3: string = "heartLose3";
    public static HEART_LOSE4: string = "heartLose4";
    public static HEART_RESTORE: string = "heartRestore";

    // FS SFS sound
    public static FS_LOOP: string = "fs";
    public static SFS_LOOP: string = "fs";
    public static MAYHEM_LOOP: string = "mayhem";
    public static FS_ENTER: string = "fsEnter";
    public static FS_INTRO: string = "spinScreen";
    public static SFS_INTRO: string = "spinScreen";
    public static FS_START: string = "fsStart";
    public static FS_STOP: string = "fsStop";
    public static FS_COUNTUP: string = "fsStopCountup";
    public static FS_OUTRO: string = "spinScreen";
    public static SFS_OUTRO: string = "spinScreen";
    
    // countup sound
    public static WIN_SMALL_COUNTUP: string = "winSmallCountup";
    public static WIN_MID_COUNTUP: string = "winLargeCountup";
    public static WIN_LARGE_COUNTUP: string = "winLargeCountup";

    // beer drink sound
    public static BEER_DRINK: string = "scatterDrinkSpin";
    
    // screen shake sound
    public static EARTHQUAKE: string = "earthquake";
    
    // banana sound
    public static BANANA_LAND: string = "bananaLand";


    private _currentMusic: string;
    private _player: NolimitAudioPlayer;

    constructor() {
        this._player = <NolimitAudioPlayer>Game.sound;
        this._player.showLogs(true);
    }

    private static createConfig(name: string, volume?: number, repeat?: number): {
        name: string;
        volume: number | undefined;
        repeat: number | undefined;
    } {
        return {
            name: name,
            volume: volume,
            repeat: repeat
        }
    }

    public get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>Game.sound;
    }

    public playSound(name: string, volume?: number, repeat?: number): void {
        this._player.playTrack(Sound.createConfig(name, volume, repeat));
    }

    public stopSound(name: string): void {
        this._player.stopTrack(name);
    }

    public fadeInAndStartSound(fadeInConf: IFadeTrackConf & {repeat?: number; isResume?: boolean}): void {
        const fade = this._player.fadeTrack(fadeInConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeInConf.duration / 1000,
                onComplete: () => {
                    if (fadeInConf.to === 0 && fadeInConf.isResume){
                        const currPlayer: NolimitHowl | undefined = Game.soundPlayer.soundPlayer.fetchSoundPlayer(fadeInConf.name);
                        currPlayer?.setVolume(0);
                        currPlayer?.resume();
                    } else if (fadeInConf.isResume){
                        const currPlayer: NolimitHowl | undefined = Game.soundPlayer.soundPlayer.fetchSoundPlayer(fadeInConf.name);
                        currPlayer?.resume();
                    } else {
                        this._player.playTrack({name: fadeInConf.name, volume: fadeInConf.to, repeat: fadeInConf.repeat != undefined ? fadeInConf.repeat : 0});
                    }
                }
            });
        } else {
            this._player.playTrack({name: fadeInConf.name});
        }

        this._currentMusic = fadeInConf.name;
    }

    public fadeOutAndStopSound(fadeOutConf: IFadeTrackConf & {isPause?: boolean}): void {
        const fade = this._player.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    if (fadeOutConf.isPause){
                        const currPlayer: NolimitHowl | undefined = Game.soundPlayer.soundPlayer.fetchSoundPlayer(fadeOutConf.name);
                        currPlayer?.pause();
                    } else{
                        this._player.stopTrack(fadeOutConf.name);
                    }
                }
            });
        } else {
            this._player.stopTrack(fadeOutConf.name);
        }
    }

    public fadeOutBGSound(): void {
        const currentMode: string = Game.getCurrentGameMode();
        let fadeOutAndStopMusic: string = Sound.MAIN_GAME_MUSIC;
        let isPause: boolean = false;

        if (currentMode === GameModeNames.MAYHEM){
            fadeOutAndStopMusic = Sound.MAYHEM_LOOP;
        } else if (currentMode === GameModeNames.SUPER_FREESPIN){
            fadeOutAndStopMusic = Sound.SFS_LOOP;
            isPause = true;
        } else if (currentMode === GameModeNames.FREESPIN){
            fadeOutAndStopMusic = Sound.FS_LOOP;
            isPause = true;
        }
        
        if (fadeOutAndStopMusic === Sound.MAIN_GAME_MUSIC) {
            Game.soundPlayer.fadeInAndStartSound({
                name: Sound.AS_SNARE,
                from: 0,
                to: 0,
                duration: 4000,
                isResume: true,
                repeat: Number.MAX_VALUE
            })

            Game.soundPlayer.fadeInAndStartSound({
                name: Sound.SNARE_PLAYER,
                from: 0,
                to: 0,
                duration: 2000,
                isResume: true,
                repeat: Number.MAX_VALUE
            })
        } else{
            Game.soundPlayer.stopSound(Sound.AS_SNARE);
            Game.soundPlayer.stopSound(Sound.SNARE_PLAYER);
        }

        Game.soundPlayer.fadeOutAndStopSound({
            name: fadeOutAndStopMusic,
            from: 1,
            to: 0,
            duration: 300,
            isPause
        })
    }

    public switchMusic(mode: GameModeNames | string): void {
        let nextMusic: string = "";

        switch (mode) {
            case GameModeNames.FREESPIN:
                nextMusic = Sound.FS_LOOP;
                break;
            case GameModeNames.SUPER_FREESPIN:
                nextMusic = Sound.SFS_LOOP;
                break;
            case GameModeNames.MAYHEM:
                nextMusic = Sound.MAYHEM_LOOP;
                break;
            default:
                nextMusic = Sound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic === Sound.MAIN_GAME_MUSIC){
            Game.soundPlayer.fadeInAndStartSound({
                name: Sound.AS_SNARE,
                from: 0,
                to: 0,
                duration: 4000,
                isResume: true,
                repeat: Number.MAX_VALUE
            });

            Game.soundPlayer.fadeInAndStartSound({
                name: Sound.SNARE_PLAYER,
                from: 0,
                to: 0,
                duration: 2000,
                isResume: true,
                repeat: Number.MAX_VALUE
            });
        } else{
            Game.soundPlayer.stopSound(Sound.AS_SNARE);
            Game.soundPlayer.stopSound(Sound.SNARE_PLAYER);
        }

        if (nextMusic === this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this._player.stopTrack(this._currentMusic);
        }

        this._player.playTrack(Sound.createConfig(nextMusic, 1, undefined));
        this._currentMusic = nextMusic;
    }
    
    public handleBGMusic(mode: string, isPlay: boolean = true): void {
        let currTrack: string = Sound.MAIN_GAME_MUSIC;

        if (mode === GameModeNames.SUPER_FREESPIN){
            currTrack = Sound.SFS_LOOP;
        } else if (mode === GameModeNames.FREESPIN){
            currTrack = Sound.FS_LOOP;
        } else if (mode === GameModeNames.MAYHEM){
            currTrack = Sound.MAYHEM_LOOP;
        }

        const currPlayer: NolimitHowl | undefined = Game.soundPlayer.soundPlayer.fetchSoundPlayer(currTrack);

        if (currTrack === Sound.MAIN_GAME_MUSIC){
            Game.soundPlayer.fadeInAndStartSound({
                name: Sound.AS_SNARE,
                from: 0,
                to: 0,
                duration: 4000,
                isResume: true,
                repeat: Number.MAX_VALUE
            });

            Game.soundPlayer.fadeInAndStartSound({
                name: Sound.SNARE_PLAYER,
                from: 0,
                to: 0,
                duration: 2000,
                isResume: true,
                repeat: Number.MAX_VALUE
            });
        } else{
            Game.soundPlayer.stopSound(Sound.AS_SNARE);
            Game.soundPlayer.stopSound(Sound.SNARE_PLAYER);
        }

        if (isPlay){
            if ([GameModeNames.SUPER_FREESPIN, GameModeNames.FREESPIN].includes(mode)){
                currPlayer?.resume();
            } else{
                this.playSound(currTrack);
            }
            this._currentMusic = currTrack;
        } else{
            if ([GameModeNames.SUPER_FREESPIN, GameModeNames.FREESPIN].includes(mode)){
                currPlayer?.pause();
            } else{
                this.stopSound(currTrack);

                Game.soundPlayer.stopSound(Sound.AS_SNARE);
                Game.soundPlayer.stopSound(Sound.SNARE_PLAYER);
            }
        }
    }
}